import React from "react";
import ReactHtmlParser from "react-html-parser";
import { Link } from "react-router-dom";
import Open from "../../assets/images/Open.png";
import Close from "../../assets/images/closed.png";
import { BodySmall, Heading3, TextLink2 } from "../common/GlobalElements/Typography";
import { Card } from "../common/GlobalElements/Card";

function ReRegistrationLeftBox(props) {
  const { registration, studentStatus, progressBar } = props;

  const handleSideBar = () => {
    document.body.classList.toggle("hide-subject-sidebar");
  };

  const InfoCard = ({ children, flexDirection = "row", alignItems = "center", className = "" }) => {
  return (
    <Card
      textAlign="start"
      padding="0.7rem"
      spacing="10px"
      alignItems={alignItems}
      justifyContent="space-between"
      flexDirection={flexDirection}
      className={`re-registration-list-opt ${className}`}
      $position="relative"
      noAction={true}
    >
      {children}
    </Card>
  );
};

  return (
    <>
      <div className="re-registration-detail-lft surface-background-color">
        <button className="close-btn-sidebar" onClick={handleSideBar}>
          <i className="close-bar close-bar-1"></i>
          <i className="close-bar close-bar-2"></i>
          <i className="close-bar close-bar-3"></i>
        </button>
        <div className="re-registration-lft-head">
          <div className="all-exam">
            <TextLink2 to="/reregistration">
              <i className="fal fa-angle-left"></i>All Applications
            </TextLink2>
          </div>

          <div className="re-registration-bx-info-top d-flex">
            <div className="icon">SA</div>
            <div className="re-registration-bx-info-right">
              <Heading3>
                {registration.academy2}
                <br />
                Intake {registration.intake_number} {registration.intake_year}
              </Heading3>

              <ul className="fa-ul">
                <li>
                  {console.log("registration",registration)}
                  <i className="fa-li fal fa-calendar-days mr-1"></i>
                  {(registration.start_date && registration.end_date) ? `${registration.start_date} to ${registration.end_date}` : "NA"}
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="re-registration-lft-body">
          <div className="re-registration-list-opt">
            <InfoCard>
              <div>
                <BodySmall $marginBottom="10px">Your Status</BodySmall>
                {registration.per || studentStatus ? (
                  <React.Fragment>
                     <i className="fal fa-user-check"></i> Submitted
                  </React.Fragment>
                ) : (
                  <React.Fragment>
                    <i className="fa-li fal fa-user-times"></i>Not Registered
                  </React.Fragment>
                )}
              </div>
            </InfoCard>

            <InfoCard flexDirection="column" alignItems="start" className="card-progress">
              <BodySmall $marginBottom="10px">  Processing status:{" "}
                {registration.status
                  ? ReactHtmlParser(registration.status == "Re-Registration Submitted" ? "Submitted" : registration.status)
                  : "Submitted"}
              </BodySmall>
              <div className="progress">
                {progressBar ? (
                  <div
                    className="progress-bar progress-bar-striped progress-bar-animated"
                    role="progressbar"
                    style={{ width: registration.per + "%" }}
                    aria-valuenow="25"
                    aria-valuemin="0"
                    aria-valuemax="10"
                  >
                    10%
                  </div>
                ) : (
                  <div
                    className="progress-bar progress-bar-striped progress-bar-animated"
                    role="progressbar"
                    style={{ width: registration.per }}
                    aria-valuenow="25"
                    aria-valuemin="0"
                    aria-valuemax="90"
                  >
                    {registration.per}
                  </div>
                )}
              </div>
            </InfoCard>

              
            <InfoCard>
              <div>
                <BodySmall $marginBottom="10px">Registration/Articulation Status</BodySmall>
                {registration.reg_status == "Closed" ? (
                  <React.Fragment>
                    <i className="fa-li open-icon"><img src={Close} /></i> CLOSED
                  </React.Fragment>
                ) : (
                  <React.Fragment>
                    <i className="fa-li open-icon"><img src={Open} /></i> OPEN
                  </React.Fragment>
                )}
              </div>
            </InfoCard>
           
            <InfoCard>
              <div>
                <BodySmall $marginBottom="10px">Re-Registration/Articulation Close Date</BodySmall>
                <i className="fa-li fal fa-calendar-days open-icon"></i> {registration.end_date}
              </div>
            </InfoCard>

          </div>
        </div>
      </div>
    </>
  );
}

export default ReRegistrationLeftBox;
